import React from 'react';

const GarantiaWidget = () => {
  return (
    <div className="bg-amber-50/50 border border-amber-200 rounded-3xl p-6 md:p-8 relative max-w-4xl mx-auto space-y-5 shadow-sm text-slate-800 animate-fadeIn">
      
      {/* Escudo dorado superior centrado */}
      <div className="flex justify-center">
        <div className="w-12 h-12 bg-amber-500 text-white rounded-full flex items-center justify-center shadow-md border-4 border-white">
          <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
        </div>
      </div>

      {/* Título de la Garantía */}
      <h4 className="text-amber-800 font-black text-center tracking-wide text-base md:text-lg uppercase">
        Garantía en Servicios Dufy Asesorías
      </h4>

      {/* Fila 1: Tarjeta Blanca con Borde Ámbar */}
      <div className="bg-white border border-amber-200/70 rounded-2xl p-4 flex gap-3 text-left items-start shadow-sm">
        <div className="w-5 h-5 rounded-full bg-amber-500 text-white flex items-center justify-center flex-shrink-0 mt-0.5 shadow-sm">
          <svg className="w-3 h-3 fill-none stroke-current" strokeWidth="3.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
        </div>
        <p className="text-xs md:text-sm text-slate-700 font-semibold leading-relaxed">
          <span className="font-black text-slate-900">Respaldamos nuestro trabajo con garantía:</span> si tu calificación es menor al <span className="text-red-600 font-black">60% de la nota máxima</span> del servicio, te reembolsamos el <span className="text-emerald-600 font-black">100% de tu dinero.</span>
        </p>
      </div>

      {/* Fila 2: Tarjeta Verde Menta */}
      <div className="bg-emerald-50/70 border border-emerald-100 rounded-2xl p-4 flex gap-3 text-left items-start shadow-sm">
        <div className="w-5 h-5 rounded-full bg-emerald-500 text-white flex items-center justify-center flex-shrink-0 mt-0.5 shadow-sm">
          <svg className="w-3 h-3 fill-none stroke-current" strokeWidth="3.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" />
          </svg>
        </div>
        <p className="text-xs md:text-sm text-emerald-900 font-semibold leading-relaxed">
          Sin embargo, nuestro compromiso va más allá: <span className="font-black text-emerald-800">nuestros resultados suelen superar el 80%</span> y siempre trabajamos para obtener la mejor nota posible.
        </p>
      </div>

      {/* Fila 3: Bloque de Nota de Texto Fino */}
      <div className="bg-white/80 border border-slate-200/50 rounded-xl p-3 text-left">
        <p className="text-[11px] text-slate-500 font-medium leading-relaxed">
          <span className="font-bold text-slate-700">Nota importante:</span> En ocasiones especiales donde no se ejecute el servicio de forma correcta, se puede pactar entre ambas partes una garantía que se ajuste a las circunstancias específicas del caso.
        </p>
      </div>

    </div>
  );
};

export default GarantiaWidget;